module.exports = __webpack_public_path__ + "static/media/instagram-2d.6da1f6a3.svg";